import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { unstageFiles } from '@/services/git/api';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

interface UnstageFilesInput {
  paths?: string[];
}

export function useUnstageFiles(): UseMutationResult<void, Error, UnstageFilesInput> {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? '');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ paths }: UnstageFilesInput) => unstageFiles(orgId, paths),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['stagedFiles', orgId] }),
  });
}
